import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container animated fadeIn" }
const _hoisted_2 = { class: "row justify-content-center align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "col-lg-2 col-mb-2 col-sm-12 col-12" }, null, -1)
const _hoisted_4 = { class: "col-lg-8 col-md-8 col-sm-10 col-12" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = { class: "form-group text-left" }
const _hoisted_8 = /*#__PURE__*/_createVNode("small", null, "Email*", -1)
const _hoisted_9 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-lg-6 col-md-6 col-sm-12" }
const _hoisted_12 = { class: "form-group text-left" }
const _hoisted_13 = /*#__PURE__*/_createVNode("small", null, "First Name*", -1)
const _hoisted_14 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_15 = { class: "col-lg-6 col-md-6 col-sm-12" }
const _hoisted_16 = { class: "form-group text-left" }
const _hoisted_17 = /*#__PURE__*/_createVNode("small", null, "Last Name*", -1)
const _hoisted_18 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-12" }
const _hoisted_21 = { class: "form-group text-left" }
const _hoisted_22 = /*#__PURE__*/_createVNode("small", null, "Username (Optional)", -1)
const _hoisted_23 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-lg-6 col-md-6 col-sm-12 mb-3 text-left" }
const _hoisted_26 = /*#__PURE__*/_createVNode("small", null, "Birthdate*", -1)
const _hoisted_27 = { class: "form-group text-left" }
const _hoisted_28 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_29 = { class: "col-lg-6 col-md-6 col-sm-12 text-left" }
const _hoisted_30 = /*#__PURE__*/_createVNode("small", null, "Occupation", -1)
const _hoisted_31 = { class: "form-group text-left" }
const _hoisted_32 = {
  key: 0,
  class: "row"
}
const _hoisted_33 = { class: "col-lg-12 col-md-12 col-sm-12" }
const _hoisted_34 = { class: "form-group text-left" }
const _hoisted_35 = /*#__PURE__*/_createVNode("small", null, "Phone Number", -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("small", null, " Link your mobile phone. This will help you secure your account. ", -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("small", { class: "text-danger" }, null, -1)
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col-lg-12 col-md-12 col-sm-12" }
const _hoisted_40 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col-lg-6 col-md-6 col-sm-12" }
const _hoisted_43 = { class: "form-group text-left" }
const _hoisted_44 = /*#__PURE__*/_createVNode("small", null, "Street*", -1)
const _hoisted_45 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_46 = { class: "col-lg-6 col-md-6 col-sm-12" }
const _hoisted_47 = { class: "form-group text-left" }
const _hoisted_48 = /*#__PURE__*/_createVNode("small", null, "Street Number*", -1)
const _hoisted_49 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_50 = { class: "col-lg-6 col-md-6 col-sm-12" }
const _hoisted_51 = { class: "form-group text-left" }
const _hoisted_52 = /*#__PURE__*/_createVNode("small", null, "Apt/Unit/Suite Number", -1)
const _hoisted_53 = { class: "text-danger" }
const _hoisted_54 = { class: "row" }
const _hoisted_55 = { class: "col-lg-6 col-md-6 col-sm-12" }
const _hoisted_56 = { class: "form-group text-left" }
const _hoisted_57 = /*#__PURE__*/_createVNode("small", null, "City*", -1)
const _hoisted_58 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_59 = { class: "col-lg-6 col-md-6 col-sm-12" }
const _hoisted_60 = { class: "form-group text-left" }
const _hoisted_61 = /*#__PURE__*/_createVNode("small", null, "Province*", -1)
const _hoisted_62 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_63 = { class: "row" }
const _hoisted_64 = { class: "col-lg-6 col-md-6 col-sm-12" }
const _hoisted_65 = { class: "form-group text-left" }
const _hoisted_66 = /*#__PURE__*/_createVNode("small", null, "Postal Code*", -1)
const _hoisted_67 = { class: "row" }
const _hoisted_68 = { class: "col-lg-12 col-md-12 col-sm-12" }
const _hoisted_69 = { class: "form-group text-left" }
const _hoisted_70 = /*#__PURE__*/_createVNode("small", null, "Address Line 2", -1)
const _hoisted_71 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_72 = { class: "row justify-content-left" }
const _hoisted_73 = { class: "col-12" }
const _hoisted_74 = /*#__PURE__*/_createVNode("label", null, " Are you involved, related, or closely associated with any members of government? ", -1)
const _hoisted_75 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_76 = { class: "form-check form-check-inline" }
const _hoisted_77 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label mr-3",
  for: "yesOption"
}, " Yes ", -1)
const _hoisted_78 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "noOption"
}, "No", -1)
const _hoisted_79 = { class: "row mt-4 mb-5" }
const _hoisted_80 = { class: "col d-flex justify-content-around" }
const _hoisted_81 = /*#__PURE__*/_createTextVNode(" Next ")
const _hoisted_82 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"1rem","height":"1rem"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"
  })
], -1)
const _hoisted_83 = /*#__PURE__*/_createVNode("div", { class: "col-lg-2 col-mb-2 col-sm-12 col-12" }, null, -1)
const _hoisted_84 = { class: "row mt-3" }
const _hoisted_85 = { class: "col" }
const _hoisted_86 = { class: "col d-flex justify-content-between align-items-center" }
const _hoisted_87 = /*#__PURE__*/_createVNode("i", { class: "fas fa-paper-plane" }, null, -1)
const _hoisted_88 = /*#__PURE__*/_createVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_tel_input = _resolveComponent("vue-tel-input")
  const _component_place_autocomplete_field = _resolveComponent("place-autocomplete-field")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_Two = _resolveComponent("Two")
  const _component_TabView = _resolveComponent("TabView")
  const _component_CardBase = _resolveComponent("CardBase")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_CardBase, {
      allowBack: true,
      title: _ctx.customerId ? 'Edit Registry' : 'Register New Customer'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TabView, { activeIndex: _ctx.activeTab }, {
          default: _withCtx(() => [
            _createVNode(_component_TabPanel, { header: "Personal Information" }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_1, [
                  _createVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createVNode("div", _hoisted_4, [
                      _createVNode("form", null, [
                        _createVNode("div", _hoisted_5, [
                          _createVNode("div", _hoisted_6, [
                            _createVNode("div", _hoisted_7, [
                              _hoisted_8,
                              _withDirectives(_createVNode("input", {
                                type: "email",
                                class: "form-control",
                                id: "email",
                                "aria-describedby": "emailHelp",
                                placeholder: "Enter email",
                                disabled: this.customerId,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.stepOneForm.props.email = $event))
                              }, null, 8, ["disabled"]), [
                                [_vModelText, _ctx.stepOneForm.props.email]
                              ]),
                              (_ctx.stepOneForm.controls.email.dirty)
                                ? (_openBlock(), _createBlock("small", _hoisted_9, _toDisplayString(_ctx.stepOneForm.controls.email.errorMessage), 1))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_10, [
                          _createVNode("div", _hoisted_11, [
                            _createVNode("div", _hoisted_12, [
                              _hoisted_13,
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                class: "form-control",
                                id: "firstName",
                                name: "firstName",
                                placeholder: "First Name",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.stepOneForm.props.firstName = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.stepOneForm.props.firstName]
                              ]),
                              (_ctx.stepOneForm.controls.firstName.dirty)
                                ? (_openBlock(), _createBlock("small", _hoisted_14, _toDisplayString(_ctx.stepOneForm.controls.firstName.errorMessage), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createVNode("div", _hoisted_15, [
                            _createVNode("div", _hoisted_16, [
                              _hoisted_17,
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                class: "form-control",
                                id: "lastName",
                                name: "lastName",
                                placeholder: "Last Name",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.stepOneForm.props.lastName = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.stepOneForm.props.lastName]
                              ]),
                              (_ctx.stepOneForm.controls.lastName.dirty)
                                ? (_openBlock(), _createBlock("small", _hoisted_18, _toDisplayString(_ctx.stepOneForm.controls.lastName.errorMessage), 1))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_19, [
                          _createVNode("div", _hoisted_20, [
                            _createVNode("div", _hoisted_21, [
                              _hoisted_22,
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                class: "form-control",
                                id: "nickname",
                                name: "nickname",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.stepOneForm.props.nickname = $event)),
                                placeholder: "Username"
                              }, null, 512), [
                                [_vModelText, _ctx.stepOneForm.props.nickname]
                              ]),
                              (_ctx.stepOneForm.controls.nickname.dirty)
                                ? (_openBlock(), _createBlock("small", _hoisted_23, _toDisplayString(_ctx.stepOneForm.controls.nickname.errorMessage), 1))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_24, [
                          _createVNode("div", _hoisted_25, [
                            _hoisted_26,
                            _createVNode("div", _hoisted_27, [
                              _withDirectives(_createVNode("input", {
                                class: "form-control",
                                type: "date",
                                name: "birthdate",
                                id: "birthdate",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.stepOneForm.props.birthdate = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.stepOneForm.props.birthdate]
                              ])
                            ]),
                            (_ctx.stepOneForm.controls.birthdate.dirty)
                              ? (_openBlock(), _createBlock("small", _hoisted_28, _toDisplayString(_ctx.stepOneForm.controls.birthdate.errorMessage), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode("div", _hoisted_29, [
                            _hoisted_30,
                            _createVNode("div", _hoisted_31, [
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                class: "form-control",
                                id: "occupation",
                                name: "occupation",
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.stepOneForm.props.occupation = $event)),
                                placeholder: "Occupation"
                              }, null, 512), [
                                [_vModelText, _ctx.stepOneForm.props.occupation]
                              ]),
                              (_ctx.stepOneForm.controls.occupation.dirty)
                                ? (_openBlock(), _createBlock("small", {
                                    key: 0,
                                    class: "text-danger",
                                    textContent: _toDisplayString(_ctx.stepOneForm.controls.occupation.errorMessage)
                                  }, null, 8, ["textContent"]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        (!_ctx.isLoading)
                          ? (_openBlock(), _createBlock("div", _hoisted_32, [
                              _createVNode("div", _hoisted_33, [
                                _createVNode("div", _hoisted_34, [
                                  _hoisted_35,
                                  _createVNode(_component_vue_tel_input, {
                                    defaultCountry: 
                            _ctx.stepOneForm.props.phoneCountry?.toLowerCase() ||
                              'ca'
                          ,
                                    value: _ctx.stepOneForm.props.phoneNumber,
                                    onInput: _ctx.changePhone,
                                    onCountryChanged: _ctx.changeCountryInputTel
                                  }, null, 8, ["defaultCountry", "value", "onInput", "onCountryChanged"]),
                                  _hoisted_36,
                                  _hoisted_37
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode("div", _hoisted_38, [
                          _createVNode("div", _hoisted_39, [
                            _hoisted_40,
                            (_ctx.isResultAddress)
                              ? _withDirectives((_openBlock(), _createBlock("textarea", {
                                  key: 0,
                                  class: "form-control mb-3",
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.autocomplete = $event)),
                                  rows: "2",
                                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.resetAutocomplete && _ctx.resetAutocomplete(...args)))
                                }, null, 512)), [
                                  [_vModelText, _ctx.autocomplete]
                                ])
                              : (_openBlock(), _createBlock(_component_place_autocomplete_field, {
                                  key: 1,
                                  onAutocompleteSelect: _ctx.selectAddress,
                                  modelValue: _ctx.autocomplete,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.autocomplete = $event)),
                                  "component-restrictions": { country: ['CA'] },
                                  libraries: ['places', '&language=EN&region=CA'],
                                  name: "autocomplete",
                                  "api-key": _ctx.apiKeyGoogle,
                                  placeholder: "Enter an address, zipcode, or location to autofill*"
                                }, null, 8, ["onAutocompleteSelect", "modelValue", "api-key"]))
                          ])
                        ]),
                        _createVNode("div", _hoisted_41, [
                          _createVNode("div", _hoisted_42, [
                            _createVNode("div", _hoisted_43, [
                              _hoisted_44,
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                class: "form-control",
                                id: "street",
                                name: "street",
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.stepOneForm.props.street = $event)),
                                placeholder: "Street*"
                              }, null, 512), [
                                [_vModelText, _ctx.stepOneForm.props.street]
                              ]),
                              (_ctx.stepOneForm.controls.street.dirty)
                                ? (_openBlock(), _createBlock("small", _hoisted_45, _toDisplayString(_ctx.stepOneForm.controls.street.errorMessage), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createVNode("div", _hoisted_46, [
                            _createVNode("div", _hoisted_47, [
                              _hoisted_48,
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                class: "form-control",
                                id: "streetNumber",
                                name: "streetNumber",
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.stepOneForm.props.streetNumber = $event)),
                                placeholder: "Street Number*"
                              }, null, 512), [
                                [_vModelText, _ctx.stepOneForm.props.streetNumber]
                              ]),
                              (_ctx.stepOneForm.controls.streetNumber.dirty)
                                ? (_openBlock(), _createBlock("small", _hoisted_49, _toDisplayString(_ctx.stepOneForm.controls.streetNumber.errorMessage), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createVNode("div", _hoisted_50, [
                            _createVNode("div", _hoisted_51, [
                              _hoisted_52,
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                class: "form-control",
                                id: "interiorNumber",
                                name: "interiorNumber",
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.stepOneForm.props.interiorNumber = $event)),
                                placeholder: "Apt/Unit/Suite Number"
                              }, null, 512), [
                                [_vModelText, _ctx.stepOneForm.props.interiorNumber]
                              ]),
                              _createVNode("small", _hoisted_53, _toDisplayString(_ctx.stepOneForm.controls.interiorNumber.errorMessage), 1)
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_54, [
                          _createVNode("div", _hoisted_55, [
                            _createVNode("div", _hoisted_56, [
                              _hoisted_57,
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                class: "form-control",
                                id: "city",
                                name: "city",
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.stepOneForm.props.city = $event)),
                                placeholder: "City*"
                              }, null, 512), [
                                [_vModelText, _ctx.stepOneForm.props.city]
                              ]),
                              (_ctx.stepOneForm.controls.city.dirty)
                                ? (_openBlock(), _createBlock("small", _hoisted_58, _toDisplayString(_ctx.stepOneForm.controls.city.errorMessage), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createVNode("div", _hoisted_59, [
                            _createVNode("div", _hoisted_60, [
                              _hoisted_61,
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                class: "form-control",
                                id: "province",
                                name: "province",
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.stepOneForm.props.province = $event)),
                                placeholder: "Province*"
                              }, null, 512), [
                                [_vModelText, _ctx.stepOneForm.props.province]
                              ]),
                              (_ctx.stepOneForm.controls.province.dirty)
                                ? (_openBlock(), _createBlock("small", _hoisted_62, _toDisplayString(_ctx.stepOneForm.controls.province.errorMessage), 1))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_63, [
                          _createVNode("div", _hoisted_64, [
                            _createVNode("div", _hoisted_65, [
                              _hoisted_66,
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                class: "form-control",
                                id: "postalCode",
                                name: "postalCode",
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.stepOneForm.props.postalCode = $event)),
                                placeholder: "Postal Code*"
                              }, null, 512), [
                                [_vModelText, _ctx.stepOneForm.props.postalCode]
                              ]),
                              (_ctx.stepOneForm.controls.postalCode.dirty)
                                ? (_openBlock(), _createBlock("small", {
                                    key: 0,
                                    class: "text-danger",
                                    textContent: _toDisplayString(_ctx.stepOneForm.controls.postalCode.errorMessage)
                                  }, null, 8, ["textContent"]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_67, [
                          _createVNode("div", _hoisted_68, [
                            _createVNode("div", _hoisted_69, [
                              _hoisted_70,
                              _withDirectives(_createVNode("textarea", {
                                class: "form-control",
                                id: "addressLine2",
                                name: "addressLine2",
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.stepOneForm.props.addressLine2 = $event)),
                                placeholder: "Address Line 2",
                                rows: "2"
                              }, null, 512), [
                                [_vModelText, _ctx.stepOneForm.props.addressLine2]
                              ]),
                              (_ctx.stepOneForm.controls.addressLine2.errorMessage)
                                ? (_openBlock(), _createBlock("small", _hoisted_71, _toDisplayString(_ctx.stepOneForm.controls.addressLine2.errorMessage), 1))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_72, [
                          _createVNode("div", _hoisted_73, [
                            _hoisted_74,
                            _hoisted_75,
                            _createVNode("div", _hoisted_76, [
                              _withDirectives(_createVNode("input", {
                                class: "form-check-input",
                                type: "radio",
                                name: "inlineRadioOptions",
                                id: "yesOption",
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.stepOneForm.props.government = $event)),
                                value: true
                              }, null, 512), [
                                [_vModelRadio, _ctx.stepOneForm.props.government]
                              ]),
                              _hoisted_77,
                              _withDirectives(_createVNode("input", {
                                class: "form-check-input",
                                type: "radio",
                                name: "inlineRadioOptions",
                                id: "noOption",
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.stepOneForm.props.government = $event)),
                                value: false
                              }, null, 512), [
                                [_vModelRadio, _ctx.stepOneForm.props.government]
                              ]),
                              _hoisted_78
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_79, [
                          _createVNode("div", _hoisted_80, [
                            _createVNode("button", {
                              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.submitStepOneForm())),
                              type: "button",
                              class: "btn btn-sat-street"
                            }, [
                              _hoisted_81,
                              _hoisted_82
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _hoisted_83
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_TabPanel, {
              header: "Documents",
              disabled: !_ctx.customerId
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Two)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_TabPanel, {
              header: "Actions",
              disabled: !_ctx.customerId
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_84, [
                  _createVNode("div", _hoisted_85, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.actions, (action) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "row",
                        key: action.template
                      }, [
                        _createVNode("div", _hoisted_86, [
                          _createVNode("b", null, _toDisplayString(_ctx.separeteByCapital(action.text)), 1),
                          _createVNode("button", {
                            class: "btn btn-success",
                            onClick: ($event: any) => (_ctx.sendEmail(action.template))
                          }, [
                            _hoisted_87
                          ], 8, ["onClick"])
                        ]),
                        _hoisted_88
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["activeIndex"])
      ]),
      _: 1
    }, 8, ["title"])
  ]))
}